const personalData =[
    {
        name: 'Randol Gonzalez',
        carrier: 'Software developer',
        info: 'As a Software Developer, I am an enthusiastic learner and collaborator, dedicated to both acquiring and sharing knowledge within collaborative team environments. My passion for technology is complemented by a diverse skill set and a strong educational background.',
    }
];
export {personalData};